export const TREETABLE_LOCALE_ZHCHS = {
    emptyMessage: 'ææ æ°æ®',
    pagination: {
        previousLabel: 'ä¸ä¸é¡µ',
        nextLabel: 'ä¸ä¸é¡µ',
        message: 'æ¯é¡µ {0} æ¡è®°å½ï¼å± {1} æ¡è®°å½ã'
    }
};
